import config from 'react-global-configuration';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
export var taxonomyTermGet = function taxonomyTermGet(termId) {
  var viewMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'taxonomyTerm']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch("".concat(PATH, "/taxonomy/term/").concat(termId, "?_format=json&viewMode=").concat(viewMode), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(taxonomyTermGetLoaded(termId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var TAXONOMY_TERM_GET_LOADED = 'TAXONOMY_TERM_GET_LOADED';
export function taxonomyTermGetLoaded(termId, data) {
  return {
    type: TAXONOMY_TERM_GET_LOADED,
    term_id: termId,
    data: data
  };
}